import React from 'react';

import { Bar } from 'victory';

export class ReleaseBar extends React.PureComponent {
    render() {
        const { spaceBetween, alignmentFn, y, ...rest } = this.props;
        const { datum } = this.props;
        const alignment = alignmentFn(datum);

        const newY = alignment === 'start' ? y - spaceBetween : y + spaceBetween;

        const newProps = {
            ...rest,
            y: newY,
            alignment,
        };
        return <Bar {...newProps} />;
    }
}
